import './App.css';
import { useState, useEffect } from 'react';

function App() {
  const [update, setUpdate] = useState(0);

  const handleButtonClick = () => {
    setUpdate(update + 1);
  };

  function handleButtonClick_clear_localstorage() {
    handleButtonClick();
    clear_localstorage();
  }
 
  function handleButtonClick_input_localstorage() {
    handleButtonClick();
    input_localstorage();
  }

  return (
    <div>
      <label class="burger" for="burger">
          <input type="checkbox" id="burger" onClick={toggleSidebar}/>
          <span></span>
          <span></span>
          <span></span>
      </label>
      <div className='side_bar'>
        <div className='empty_space'>ㅤ</div>
        <div className='sideBar_el'>Todo List</div>
        <hr className='sideBar_hr'/>
        <div className='sideBar_el'>Notice</div>
        <hr className='sideBar_hr'/>
        <div className='sideBar_el'>Developer</div>
        <hr className='sideBar_hr'/>
      </div>
      <div className='main_frame'>
        <br/>
        <div className='add_frame'>
          <input type='text' id='input_text_todo' className='input_todo' placeholder='Enter List'/>
          <span className='just_stick'>ㅣ</span>
          <span className='add_button' id='add_todo_button' onClick={handleButtonClick_input_localstorage}>+</span>
        </div>

        <br/>

        <div className='sub_frame'>
          <div className='list_frame'> 
            <div className='list_el'>
              <div className='list_title'>
                <div className='TodoListText'><h2>Todo List</h2></div>
                <span onClick={handleButtonClick_clear_localstorage} className='all_clear'>전체삭제</span>
              </div>
              <hr className='custom_hr'/>
              <Add_list_el key={update} onUpdate={handleButtonClick}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
//--------------------------------COMPONENT--------------------------------
function Add_list_el({ onUpdate }) {
  let [arr_todo_list, set_arr_todo_list] = useState(bring_localStorage_todo_list());
  let [checkboxStates, setCheckboxStates] = useState(() => bring_localStorage_checkbox_states());

  useEffect(() => {
    localStorage.setItem('checkbox_states', JSON.stringify(checkboxStates));
  }, [checkboxStates]);

  const handleDelete = (index) => {
    let updatedList = arr_todo_list.filter((_, i) => i !== index);
    set_arr_todo_list(updatedList);
    localStorage.setItem('localStorage_todo_list', JSON.stringify(updatedList));

    // 업데이트된 체크박스 상태를 새로운 배열로 생성하여 로컬 스토리지에 저장
    let updatedCheckboxStates = {};
    Object.keys(checkboxStates).forEach((key) => {
      if (parseInt(key) !== index) {
        const newKey = key > index ? key - 1 : key;
        updatedCheckboxStates[newKey] = checkboxStates[key];
      }
    });
    setCheckboxStates(updatedCheckboxStates);
    localStorage.setItem('checkbox_states', JSON.stringify(updatedCheckboxStates));

    onUpdate();
  };

  const handleCheckboxChange = (index) => {
    let updatedCheckboxStates = { ...checkboxStates, [index]: !checkboxStates[index] };
    setCheckboxStates(updatedCheckboxStates);
  };

  return (
    <>
      {arr_todo_list.map((item, index) => (
        <div key={index}>
          <div className='element_frame'>
            <div className='list_text'>{item}</div>
            <div className='checkbox-wrapper-29'>
              <label className='checkbox'>
                <input 
                  type='checkbox' 
                  className='checkbox__input' 
                  checked={checkboxStates[index] || false}
                  onChange={() => handleCheckboxChange(index)}
                />  
                <span className='checkbox__label'></span>
                ㅤ
              </label>
            </div>
            <span className='delete' onClick={() => handleDelete(index)}>삭제</span>
          </div>
          <hr className='list_hr'/>
        </div>
      ))}
    </>
  );
}
//--------------------------------COMPONENT--------------------------------
//--------------------------------FUNCTION--------------------------------
let a = '';
let todo_list = [];

function input_localstorage() {
  let a = document.getElementById('input_text_todo').value;
  
  let todo_list = bring_localStorage_todo_list();

  if (a.trim()) {
      todo_list.push(a);
      localStorage.setItem('localStorage_todo_list', JSON.stringify(todo_list));
  }
}

function clear_localstorage() {
    localStorage.clear()
    todo_list = [];
    localStorage.setItem('localStorage_todo_list', JSON.stringify(todo_list))
}

/**데이터를 로컬스토리지에서 todo_lsit에 가져와서 리턴하는 함수*/
function bring_localStorage_todo_list() {
  const storedList = localStorage.getItem('localStorage_todo_list');
  if (storedList) {
      return JSON.parse(storedList);
  }
  return [];
}

/**데이터를 로컬스토리지에서 checkbox 상태를 가져와서 리턴하는 함수 */
function bring_localStorage_checkbox_states() {
  const storedCheckboxStates = localStorage.getItem('checkbox_states');
  if (storedCheckboxStates) {
    return JSON.parse(storedCheckboxStates);
  }
  return {};
}

function toggleSidebar() {
  const sidebar = document.querySelector('.side_bar');
  if (sidebar.style.right === '0px') {
    sidebar.style.right = '-300px';
  } else {
    sidebar.style.right = '0px';
  }
}
//--------------------------------FUNCTION--------------------------------
export default App;